var map = {
	"./100ml.png": 3696,
	"./200ml.png": 552,
	"./300ml.png": 6232,
	"./400ml.png": 3448,
	"./500ml.png": 4559,
	"./bell.png": 1952,
	"./bill.png": 6728,
	"./capsule.png": 796,
	"./cardiogram.png": 7652,
	"./dr_acacia.png": 488,
	"./dricon.png": 1248,
	"./drug.png": 6319,
	"./eyedrop.png": 960,
	"./group-logo.png": 4872,
	"./medication.png": 3916,
	"./quote-request.png": 4400,
	"./smartphone.png": 6831,
	"./syringe.png": 6600,
	"./tablet.png": 1340,
	"./water.png": 5276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9868;